import { environment } from '~env/environment';

export const API_FILTERS_ROUTE_V3 = () => `${environment.svcSearch2BaseUrl()}/api/v3/filters`;
export const API_CUSTOM_PLP_ROUTE = () =>
  `${environment.getSvcStorefrontBaseUrl()}/api/v1/public/${environment.countryDomainCode()}/cms/custom-plp/view`;
export const API_SEO_CONTENT_ROUTE = () =>
  [
    environment.getSvcStorefrontBaseUrl(),
    '/api/v1/public/',
    environment.countryDomainCode(),
    '/cms/seo-content/category/id'
  ].join('');
export const API_BUYER_CATEGORIES_ROUTE = () => `${environment.svcBuyerCategories()}/api/categories`;
export const API_CMS_CAROUSEL_ROUTE = () =>
  `${environment.getSvcStorefrontBaseUrl()}/api/v1/public/${environment.countryDomainCode()}/cms/carousel/view`;
